import { StateResolver, StateResolverContext } from '@workspace/core-ts/types';
import { StepProps, getStepBySlug } from '@workspace/core-ts/utils';

/**
 * Résolveur d'état spécifique au formulaire Vélo
 * Étapes : votre-velo -> votre-besoin -> votre-tarif -> vos-coordonnees -> votre-recapitulatif -> paiement -> validation -> signature -> pieces-justificatives
 */
export class VeloStateResolver implements StateResolver {
    resolveStepFromState(state: string, context: StateResolverContext): StepProps | null {
        const { isAvenant, finalForm, source, steps } = context;

        let possibleStep: StepProps | null = null;

        // Logique de résolution basée sur l'état
        switch (state) {
            case 'new':
                if (isAvenant) {
                    // Pour les avenants, on commence par la sélection du motif
                    possibleStep = getStepBySlug('selection-motif-avenant', steps);
                } else {
                    // Pour les affaires nouvelles, on commence par l'étape vélo
                    possibleStep = getStepBySlug('votre-velo', steps);
                }
                break;

            case 'tarif':
            case 'devis':
                if (finalForm.DemandeTarif?.Subscribe) {
                    possibleStep = getStepBySlug('recapitulatif', steps);
                } else if (
                    !finalForm.gptConsent &&
                    ['AppGPT', 'AgentConv'].includes(context.data?.data?.DemandeDevis?.TypeMER)
                ) {
                    possibleStep = getStepBySlug('recap-gpt', steps);
                } else {
                    possibleStep = getStepBySlug('votre-tarif', steps);
                }
                break;


            case 'contrat_en_attente_de_paiement':
                // DIFFÉRENCIATION AVENANT vs AFFAIRE NOUVELLE
                if (isAvenant) {
                    // Pour les avenants : validation automatique (mutationPay au mount)
                    possibleStep = getStepBySlug('validation-paiement-avenant', steps);
                } else if (finalForm.DemandeTarif?.Subscribe) {
                    // Souscrire (depuis Deals) : on poursuit vers le paiement
                    possibleStep = getStepBySlug('paiement', steps);
                } else if (source !== 'site') {
                    // Gestionnaire (Modifier) : retour à la première étape pour permettre la modification et recréer un devis
                    possibleStep = getStepBySlug('votre-velo', steps);
                } else {
                    // Site : va vers l'étape de paiement
                    possibleStep = getStepBySlug('paiement', steps);
                }
                break;

            case 'contrat_en_cours_de_validation':
            case 'contrat':
                // Après paiement, on passe à la validation
                possibleStep = getStepBySlug('validation', steps);
                break;

            default:
                // Si l'état n'est pas reconnu, on ne change pas d'étape
                possibleStep = null;
        }

        return possibleStep;
    }
}
